import { USCurrency } from 'components/ReusableComponents/FormattedPrice'
import moment from 'moment'

import styles from './BillableItems.module.scss'

const BillableItems = ({ invoiceDetails }) => {
  const {
    totalFixedServices,
    totalMessageFees,
    beginDate,
    endDate,
    customMessagesBeginDate,
    customMessagesEndDate
  } = invoiceDetails

  if (!totalFixedServices && !totalMessageFees) return null

  return (
    <div className={styles.billableItems}>
      <p className={styles.billableItemsTitle}>Billable items</p>
      {totalFixedServices > 0 && (
        <div className={styles.billableItem}>
          <div className={styles.billableItemText}>
            <p className={styles.billableItemTitle}>Directful core services</p>
            <p className={styles.billableItemDescription}>
              For {moment(beginDate).format('MMM DD, YYYY')} -{' '}
              {moment(endDate).format('MMM DD, YYYY')}
            </p>
          </div>
          <div className={styles.billableItemPrice}>
            <USCurrency withCode>{totalFixedServices}</USCurrency>
          </div>
        </div>
      )}
      {totalMessageFees > 0 && (
        <div className={styles.billableItem}>
          <div className={styles.billableItemText}>
            <p className={styles.billableItemTitle}>Text blasts and announcements</p>
            <p className={styles.billableItemDescription}>
              For {moment(customMessagesBeginDate).format('MMM DD, YYYY')} -{' '}
              {moment(customMessagesEndDate).format('MMM DD, YYYY')}
            </p>
          </div>
          <div className={styles.billableItemPrice}>
            <USCurrency withCode>{totalMessageFees}</USCurrency>
          </div>
        </div>
      )}
    </div>
  )
}

export default BillableItems
